import { useTranslation } from 'react-i18next';
import { useToast } from '@/providers/Toast.provider';
import { useDataFetchIndicator } from '@/hooks';
import useFetchPartnerAccounts from '@/hooks/useApi/useFetchPartnerAccounts';

export default function useOpenAccountDetails() {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Transaction.Details.TransactionCard',
  });

  const toast = useToast();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [, , , fetchPartnerAccountsAsync] = useFetchPartnerAccounts({});

  // Account Details page reads balance figures from the URL, so we need to get them here before opening the page.
  return async function openAccountDetails(accountId: string, currency: string) {
    setDataFetchingInfo(true, '', 'fullScreen');

    try {
      const response = await fetchPartnerAccountsAsync({ VopayAccountID: accountId, Limit: 1 });

      const matched =
        response.balances.find((b) => b.AccountID === accountId && b.Currency === currency) ??
        response.balances.find((b) => b.AccountID === accountId);

      if (!response.success || !matched) {
        toast.neutral(t('fetchingError', { defaultValue: 'Failed to open account details' }));

        return;
      }

      const search = new URLSearchParams({
        accountId: matched.AccountID,
        isActive: String(matched.IsActive),
        accountStatus: matched.AccountStatus,
        currency: matched.Currency,
        pending: matched.PendingBalance,
        available: matched.AvailableBalance,
        account: matched.AccountBalance,
        reserve: matched.Reserve,
        immediate: matched.AvailableImmediately,
      });

      window.open(`/accounts/${accountId}?${search.toString()}`, '_blank');
    } catch (err) {
      console.error(err);
      toast.neutral(t('fetchingError', { defaultValue: 'Failed to open account details' }));
    } finally {
      setDataFetchingInfo(false);
    }
  };
}
